import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LorenImageCropperDialogComponent } from "./components/loren-image-cropper-dialog/loren-image-cropper-dialog.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSliderModule } from "@angular/material/slider";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { ImageCropperComponent } from "ngx-image-cropper";

import { TranslocoModule } from "@jsverse/transloco";

@NgModule({
  declarations: [LorenImageCropperDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressBarModule,
    MatSliderModule,
    TranslocoModule,

    ImageCropperComponent,
  ],
  exports: [LorenImageCropperDialogComponent],
})
export class LorenImageCropperDialogModule {}
